var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "layerDom",
      staticClass: "flex justify-center items-center",
      class: _vm.$style["layer--lang-switch"],
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.emit("close")
        }
      }
    },
    [
      _c("div", { ref: "panelDom", class: _vm.$style["lang-switch-panel"] }, [
        _vm.token
          ? _c("div", { staticClass: "langHeaderUser" }, [
              _c("div", { staticClass: "langHeaderUserEmail" }, [
                _vm._v(_vm._s(_vm.user.email))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "langHeaderUserId" }, [
                _vm._v("ID:" + _vm._s(_vm.user.id)),
                _c("i", {
                  staticClass: "copy iconfont icon-fuzhi",
                  attrs: { "data-clipboard-text": _vm.user.id },
                  on: { click: _vm.handleCopy }
                })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { class: _vm.$style["panel-body"] }, [
          _c("div", { class: _vm.$style["scroll-box"] }, [
            _c(
              "div",
              {
                staticClass: "overflow-hidden",
                class: _vm.$style["lang-group"]
              },
              [
                _c("div", { class: _vm.$style["group-title"] }, [
                  _c("span", { staticClass: "text" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("400005")) +
                        "\n                        "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "grid grid-cols-2",
                    class: _vm.$style["group-body"]
                  },
                  _vm._l(_vm.langOptions, function(item, index) {
                    return _c(
                      "button",
                      {
                        key: index,
                        class: _vm.$style["option"],
                        attrs: {
                          "data-active": _vm.currentSelectLang === item.language
                        },
                        on: {
                          click: function() {
                            _vm.changeCurtSelectLang(item)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(item.name))
                        ])
                      ]
                    )
                  }),
                  0
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.$style["langFooter"] }, [
          !_vm.token
            ? _c("div", { class: _vm.$style["langBtns"] }, [
                _c(
                  "div",
                  {
                    class: _vm.$style["btn--connect-logIn"],
                    on: { click: _vm.toLogin }
                  },
                  [
                    _c("span", { class: _vm.$style["text"] }, [
                      _vm._v(_vm._s(_vm.$t("300328")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { class: _vm.$style["btn--connect-register"] }, [
                  _c(
                    "span",
                    {
                      class: _vm.$style["text"],
                      on: { click: _vm.toRegister }
                    },
                    [_vm._v(_vm._s(_vm.$t("300041")))]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.$style["downLoad"],
              on: {
                click: function($event) {
                  return _vm.$router.push({ path: "/download" })
                }
              }
            },
            [
              _c("UeIcon", {
                class: _vm.$style["ic"],
                attrs: { name: "download" }
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("300332")))])
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a574f4d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a574f4d4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/newHome/LanguageSwitch.vue
// module id = s5E1
// module chunks = 0